<template>
  <div>
    <small class="text-grey lighten-1">Key: {{fieldKey}}</small>
    <v-switch
      :label="item.content? 'Enable' : 'Disable'"
      v-model="item.content"
      v-if="item.type === 'switch'"
    />
    <content-field
      v-if="item.type === 'input'"
      :label="item.label"
      v-model="item.content"
      @input="changeValue"
    />
    <content-field
      v-else-if="item.type === 'url'"
      :label="item.label"
      v-model="item.content"
      @input="changeValue"
    />
    <content-editor
      v-else-if="item.type === 'textarea'"
      :placeholder="item.label"
      v-model="item.content"
      @input="changeValue"
    />

    <v-card
      v-else-if="item.type === 'image'"
      width="320"
    >
      <div class="grey lighten-2">
        <v-card-media height="130" :src="item.content"/>
      </div>

      <v-card-title><h3>{{item.label}}</h3></v-card-title>
      <v-card-actions>
        <v-btn
          flat
          color="success"
          @click.native="selectImage">Choose</v-btn>
        <v-btn
          flat
          color="error"
          :disabled="!item.content"
          @click="resetImage()">Reset
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-layout
      class="my-2"
      v-else-if="item.type === 'array'"
      row justify-space-around
      wrap
    >
      <v-btn class="green white--text" @click="createNewItem">Create new item</v-btn>
      <v-flex xs12 d-flex style="flex-wrap: wrap;">
        <div
          class="mx-2"
          v-for="(el, key) in item.content"
          :key="key"
        >
          <static-content-field
            :item="el"
            :fieldKey="key"
            :name="key"
          />
          <v-btn class="red white--text mx-auto" @click="deleteItem(key)">Delete</v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-card v-else-if="item.type === 'color'">
      <e-color-picker
        :label="item.label"
        :value="item.content"
        @colorChange="changeValue"
      />
    </v-card>

    <v-layout
      v-else-if="item.type === 'object'"
      column
    >
      <h3>{{item.value}}</h3>
      <v-flex xs12>
        <v-layout row wrap class="mx-2 my-4">
          <div
            class="object-fields__width"
            v-for="(el, key) in item.content"
            :key="key"
          >
            <static-content-field
              class="object-fields__width"
              :item="el"
              :fieldKey="key"
              :name="key"
            />

         </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
import ContentField from '@/components/shared/ContentField'
import ContentEditor from '@/components/shared/ContentEditor'
import GalleriesList from '@/components/pages/Gallery/GalleriesList'
import EColorPicker from '@/components/shared/EColorPicker'
import mixins from '@/utils/mixins'

export default {
  name: 'StaticContentField',
  props: {
    item: {
      type: Object,
      required: true,
      validator: val =>
      val.hasOwnProperty('type') && ['input', 'url', 'textarea', 'image', 'object', 'array', 'color', 'switch'].includes(val.type)
    },
    fieldKey: {
      type: String,
      required: true
    }
  },
  components: {
    ContentField,
    ContentEditor,
    GalleriesList,
    EColorPicker
  },
  methods: {
    changeValue (e) {
      this.$emit('changeTextValue', { value: e, key: this.fieldKey })
    },
    resetImage () {
      this.$bus.$emit('resetImage', this.fieldKey)
    },
    selectImage () {
      this.$bus.$emit('openGallery', this.fieldKey)
    },
    createNewItem () {
      this.$bus.$emit('createNewItem', this.fieldKey)
    },
    deleteItem (key) {
      this.$bus.$emit('delteItemFromArray', key)
    }
  }
}
</script>

<style lang="scss" scoped>
  .object-fields__width {
    width: 450px;
    margin: 0 30px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/StaticPages/dataField.vue